export const MODESTATE = {
    PAINT: 'paint', // 涂抹、画笔
    ERASER: 'eraser', // 擦除、橡皮
}

export const OPERATETYPE = {
    DRAW: 'draw', // 涂抹
    RECT: 'rect', // 框选
    CIRCLE: 'circle', // 圈选
}